export default __webpack_public_path__ + "static/media/Alison 9781408333921.c9b91701.jpg";